var store = require('../store')

module.exports = {
  replace: true,
  props: ['params'],
  data: function () {
    return {
      params: {
        userId: null
      },
      user: {}
    }
  },
  watch: {
    'params.userId': 'update'
  },
  compiled: function () {
    this.update()
  },
  methods: {
    update: function () {
      store.fetchUser(this.params.userId, function (user) {
        this.user = user
      }.bind(this))
    }
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ../vue-loader/lib/selector.js?script!./src/views/user-view.vue
 ** module id = 105
 ** module chunks = 0
 **/